module.exports = __webpack_public_path__ + "img/bs.048f2070.svg";